import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function AF(props) {
    return (
        <FontAwesomeIcon icon={props.icon} className={props.size} />
    );
}